import React from 'react';
import styled from 'styled-components';
import * as d3 from 'd3';
import { LABEL } from './Diff';

const SERIES_LABEL = {
    sessionsAtSrc: 'Sessions — this URL',
    sessionsAtDst: 'Sessions — destination URL',
    clicks: 'Search Console clicks',
    impressions: 'Search Console impressions',
};

export default function ChartTooltip({ active, payload, label, showPosition }) {
    if (!active || !payload || !payload.length) return null;
    const data = payload[0].payload;
    const dateStr = d3.timeFormat('%d %b %Y')(new Date(label));
    const changes = Object.keys(data).filter(k => data[k] === true && LABEL[k]).map(k => LABEL[k]);
    const isError    = data._crawlFailed || (data._httpStatus && parseInt(data._httpStatus, 10) >= 300);
    const statusColor = isError ? '#dc2626' : data._nonIndexable ? '#f59e0b' : null;
    const statusLabel = data._crawlFailed ? 'Crawl failed'
        : data._httpStatus ? `HTTP ${data._httpStatus}`
        : data._nonIndexable ? 'Non-indexable'
        : null;

    return (
        <TipBox>
            <TipDate>{dateStr}</TipDate>
            {payload.filter(p => p.value > 0 && SERIES_LABEL[p.dataKey]).map(p => (
                <TipRow key={p.dataKey}>
                    <TipDot style={{ background: p.stroke }} />
                    <span>{SERIES_LABEL[p.dataKey]}</span>
                    <TipVal>{p.value}</TipVal>
                </TipRow>
            ))}
            {showPosition && data.position != null && (
                <TipRow>
                    <TipDot style={{ background: '#fdba74' }} />
                    <span>Average position</span>
                    <TipVal>{data.position.toFixed(1)}</TipVal>
                </TipRow>
            )}
            {statusLabel && (
                <TipStatusRow>
                    <TipDot style={{ background: statusColor }} />
                    <span>{statusLabel}</span>
                </TipStatusRow>
            )}
            {changes.length > 0 && <TipChanges>Changed: {changes.join(', ')}</TipChanges>}
        </TipBox>
    );
}

const TipBox = styled.div`
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 10px 14px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.08);
    font-size: 0.78rem;
    min-width: 140px;
`;

const TipDate = styled.div`
    font-size: 0.72rem;
    font-weight: 700;
    color: #0f172a;
    margin-bottom: 6px;
`;

const TipRow = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    color: #374151;
    margin-bottom: 3px;
`;

const TipDot = styled.span`
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
`;

const TipVal = styled.span`
    margin-left: auto;
    font-weight: 600;
    color: #0f172a;
`;

const TipStatusRow = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    color: #374151;
    margin-top: 4px;
    font-weight: 600;
`;

const TipChanges = styled.div`
    margin-top: 6px;
    padding-top: 6px;
    border-top: 1px solid #f1f5f9;
    font-size: 0.7rem;
    color: #6366f1;
    font-weight: 500;
`;
